import { isEyes } from './helpers';

export const sessionLoggedIn = {
  user: {
    loggedin: true,
    username: 'autobob1',
    usericon: 'https://a.deviantart.net/avatars/a/u/autobob1.gif?1',
    type: 'premium',
    email: 'me@me.com',
    verified: true,
    newsletter: true,
    sex: 'o',
    dob: '2000-01-01',
    joindate: '2011-11-24T07:19:09-0800',
    country: 'United States Minor Outlying Islands',
    timezone: 'Europe/London',
    theme: 'dark',
    userId: 33333,
    hasCoreMembership: true,
    useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
    sessionId: '54f3ddf64cad3f7acb72fab0eb1d307b',
    biClientId: 'f9651960-2e49-47ea-8309-a95a7c0ea750',
    usericonDefault: false,
    matureContent: true,
    utId: '3FFE033F-00E9-EBBF-7F34-9FA3C44E6E7A',
    dobPublic: '200-01-01',
    authMode: 'DA',
    eclipseSwitcher: true,
    pagingMode: 'scroll',
    privacy: {
      cookies: {
        accepted: false,
        required: false,
        types: {
          functional: false,
          analytics: false,
          marketing: false,
        },
      },
    },
    coreLevel: 'core_access',
  },
  features: [],
  geo: { countryCode: 'us' },
  seo: {
    canonical: 'https://www.deviantart.lan',
    title: 'DeviantArt',
    description: 'DeviantArt',
  },
  trackers: {
    quantcast: 'UserStatus.LoggedIn',
    ganalytics: [
      'ga("create","UA-322734-1",".deviantart.com",{"userId":"3FAE033F-00E9-EBBF-7F34-9FA3C44E6E7A"});',
      'ga("set","dimension2","12_plus_months");',
      'ga("set","dimension6","menu_dropdown-messages_dropdown");',
      'ga("send","pageview",{"dimension4":0});',
    ],
  },
  device: {
    isMobile: false,
    isMobileDevice: false,
    isTablet: false,
    supportsLazy: true,
  },
  csrfToken:
    'R2hPNy-BxDTdWxwY.p6nnad.HzJZQSgOZ7UzvC6socnoP3R4wuozMhR3GlfbM-Prkyg',
  requestId: '592m9643737921243f13f911a383cd288b76',
  firstTimeFlags: [],
  adProviders: [],
  counts: {
    feedback: isEyes() ? 500 : Math.floor(Math.random() * 9999),
    watch: isEyes() ? 200 : Math.floor(Math.random() * 9999),
    notes: isEyes() ? 1400 : Math.floor(Math.random() * 9999),
    points: isEyes() ? 640 : Math.floor(Math.random() * 9999),
    cart: isEyes() ? 320 : Math.floor(Math.random() * 9999),
  },
  damz: {
    endpoint: 'http://supabase.deviantart.com',
    anonToken: '1234567890',
    authSession: 'some-auth-session',
  },
};
